import { useQuery } from '@tanstack/react-query'

import { fetchReservationDetail } from '@/lib/venue/reservationApi'
import type { ReservationDetailView } from '@/lib/venue/reservationTypes'

export function reservationDetailQueryKey(venueId: string, reservationId: number) {
  return ['venue', venueId, 'reservation', reservationId] as const
}

export function useVenueReservationDetail(venueId: string, reservationId: number) {
  return useQuery<ReservationDetailView>({
    queryKey: reservationDetailQueryKey(venueId, reservationId),
    queryFn: () => fetchReservationDetail(venueId, reservationId),
  })
}
